"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isResolvedErr = exports.isRejected = exports.isFulfilled = void 0;
const isFulfilled = (promise) => promise.status === 'fulfilled';
exports.isFulfilled = isFulfilled;
const isRejected = (promise) => promise.status === 'rejected';
exports.isRejected = isRejected;
const isResolvedErr = (promise) => 'value' in promise && promise.value.isErr();
exports.isResolvedErr = isResolvedErr;
